import { WeddingMap } from "./weddingMap";

document.addEventListener("DOMContentLoaded", () => {
  Array.from(document.getElementsByClassName("bwd-map")).forEach((cmp) => {
    new WeddingMap(cmp);
  });
});
